import { useMemo } from 'react'
import { Field } from 'react-final-form'

import FormItem from 'common/components/formItem'
import IconTitleGroup from 'common/components/iconTitleGroup'
import InputCombobox from 'common/components/inputCombobox'
import useGetMergeTagsQuery from 'features/admin/accountSettings/api/queries/useGetMergeTagsQuery'

const MergeTags = () => {
  const { data: mergeTags, isLoading, isError } = useGetMergeTagsQuery()

  const mergeTagItems = useMemo(
    () =>
      mergeTags
        ?.map((tag) => ({
          id: tag.id,
          label: tag.name,
          value: tag.id,
          tooltip: (
            <div>
              <p className="mb-2">Personalisation tag code</p>
              {tag.code}
            </div>
          ),
        }))
        .sort((a, b) => a.label.localeCompare(b.label)) || [],
    [mergeTags]
  )

  return (
    <>
      <hr className="w-full my-6 border-gold-400" />
      <div className="flex flex-col mb-6">
        <IconTitleGroup title="Personalisation tags" />
        <span className="text-base-700 text-base mt-1 mb-4">
          Personalisation tags allow you to include dynamically populated data
          fields in your content.
        </span>
        {mergeTagItems.length === 0 ? (
          <span className="text-base-700 text-base mt-4">
            No personalisation tags have been set up.
          </span>
        ) : (
          <FormItem guidingText="Select up to 4 tags to guide your messaging. The system will include them where appropriate. ">
            <Field<string[]>
              name="merge_tags"
              render={({ input }) => (
                <InputCombobox
                  items={mergeTagItems}
                  selectedItems={input.value}
                  name={input.name}
                  onApply={input.onChange}
                  isLoading={isLoading}
                  maxOptions={4}
                  placeholder="Select Personalisation tags"
                  isDisabled={isLoading || isError}
                  menuPlacement="top"
                />
              )}
            />
          </FormItem>
        )}
      </div>
    </>
  )
}

export default MergeTags
